// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__c10d3","bigColWidth":"Table_bigColWidth__owwqS","biggerColWidth":"Table_biggerColWidth__3uuQd","row":"Table_row__1_Zg1","col":"Table_col__MaghP"};